"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useBarcodeReader;
var _library = require("@zxing/library");
var _react = require("react");
function useBarcodeReader(_ref) {
  var cameraRef = _ref.cameraRef,
    deviceId = _ref.deviceId,
    onError = _ref.onError,
    onScan = _ref.onScan;
  var onScanRef = (0, _react.useRef)(null);
  var onErrorRef = (0, _react.useRef)(null);
  var readerRef = (0, _react.useRef)(null);
  var startScanning = (0, _react.useCallback)(function () {
    readerRef.current.decodeFromVideoDevice(deviceId, cameraRef.current, function (code, err) {
      if (code) {
        onScanRef.current(code);
      }
      if (err && onErrorRef.current) {
        console.error(err);
        onErrorRef.current(err);
      }
    });
  }, [deviceId, cameraRef]);
  var stopScanning = (0, _react.useCallback)(function () {
    if (readerRef.current) {
      readerRef.current.reset();
    }
  }, []);

  // Update ref.current value if handlers change.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  (0, _react.useEffect)(function () {
    onScanRef.current = onScan;
    onErrorRef.current = onError;
  }, [onScan, onError]);
  (0, _react.useEffect)(function () {
    readerRef.current = new _library.BrowserMultiFormatReader();
    return function () {
      return stopScanning();
    };
  }, [stopScanning]);
  return {
    startScanning,
    stopScanning
  };
}